import {Injectable} from '@angular/core';
import {ApiBackendService} from './api-backend.service';
import {BehaviorSubject} from 'rxjs';
import {Photo} from '../entities/photo';
import {map} from 'rxjs/operators';
import {Router} from '@angular/router';
import {AppService} from './app.service';

@Injectable({
  providedIn: 'root'
})
export class ImagesService {
  photos: BehaviorSubject<Photo[]> = new BehaviorSubject<Photo[]>([]);
  cachedImageIds: number[] = [];
  selectedPhotoId: number;

  constructor(private apiBackendService: ApiBackendService,
              private appService: AppService,
              private router: Router) {
  }

  getPhoto(photoId: number) {
    if (!this.cachedImageIds.some(imageId => imageId === photoId)) {
      this.cachedImageIds.push(photoId);
      // TODO spinner this.spinnerService.openSpinner();
      this.apiBackendService.getPhoto(photoId)
        .pipe(map(photo => ({
          ...photo,
          path: 'data:image/jpeg;charset=utf-8;base64, ' + photo.path
        })))
        // TODO spinner finalize(() => this.spinnerService.closeSpinner()))
        .subscribe(photo => {
          if (photo && photo.path) {
            this.photos.next([...this.photos.value, photo]);
          }
        }, error => {
          console.error(error);
        });
    }
  }

  openPhoto(selectedId: number) {
    this.selectedPhotoId = selectedId;
    this.appService.galleryOpen.next(true);
    this.router.navigate(['gallery']);
  }
}
